<template>
  <div class="listingContainer" data-test-id="listing_details_main_specs">
    <benefits-header class="benefitsHeaderWrapper" :on-hide="wholesale" />
    <WholesaleBanner v-if="wholesale" />
    <div class="layout">
      <ErrorMessage class="errorWrapper" v-if="error" />
      <div v-if="details && !loading" class="listingDetails">
        <Image-grid @load-image="onHide()" :details="details" />
        <ListingInfo @show-test-drive-modal="showTestDriveModal = true" @show-lead-modal="popupLeadModal" @click-buy="clickBuy" @click-trade-in="clickTradeIn" @scroll-to="scrollTo" :details="details" :loan-calculation="loanCalculation" :wholesale="details.wholesalePrice?.value" :has-slider-offers="hasSliderOffers" />
        <Specs :details="details" />
        <ToggleSpecsList :details="details">
          <template #slideroffers>
            <!-- Sample referenceNumber {{ 548605 }}; The referenceNumber's value must be an integer. -->
            <div v-if="!wholesale && hasLeasePrice && details.referenceNumber.match(/\d+/)" id="findleasing-offer-embed-div" class="sliderOffersWrapper" :class="{ hidden: !hasSliderOffers }" ref="sliderOffers">
              <h2 id="leasingHeader" class="sliderOffersHeading">Leasingberegner</h2>
              <div data-findleasing :data-seller="dataSeller" :data-id="details.referenceNumber" data-funding="financial" />
            </div>
          </template>
        </ToggleSpecsList>
        <TradeInBanner v-if="!wholesale" @click-trade-in="clickTradeIn" />
        <VideoBanner v-if="!wholesale" @click-test-drive="showTestDriveModal = true" />
      </div>
    </div>
    <div v-if="details && !loading" class="bottomSession">
      <span v-if="!wholesale">
        <Benefits />
        <div v-if="hasRetailPrice" class="calculator">
          <div>
            <seez-sdk-calculator ref="calculator" :listing="details.id" lg="da">
              <h1 class="calculatorHeading" style="font-weight: 100 !important">Låneberegner</h1>
            </seez-sdk-calculator>
          </div>
        </div>
      </span>
      <div ref="related" class="related" :class="{ hidden: !relatedTotal }">
        <h2>{{ t['you_might_like'] }}</h2>
        <seez-sdk-carousel @track="e => $root.trackEvent(e)" :placeholder="$root.cardPlaceholder" :style="cardStyles" ref="carousel" :filters="noRelated ? sameModelFilter : relatedFilter" to="/biler/{brand}/{model}/{id}" @select="goToCar" @loaded="e => relatedLoaded(e)" @click-payment="e => clickPayment(e)" lg="da" />
        <router-link @click="$root.track($root.events.CTA_CLICK, { properties: { event_label: 'search_all_listing_page' } })" to="/soegeresultater" data-test-id="added_search_button">
          {{ t['browse_all_vehicles'] }}
        </router-link>
      </div>
      <div class="layout">
        <ModelsInfoBanner v-if="!wholesale" />
      </div>
      <div ref="wholesaleBanner" v-if="wholesale" class="wholesaleBannerWrapper">
        <div class="wholesaleBanner">
          <h2>Lad en uvildig Recar mekaniker kontrollere bilen for eventuelle fejl og mangler.</h2>
          <div class="flexIcons">
            <div>
              <!-- <img src="/assets/listing/form-check.png" /> -->
              <!-- TODO: REMOVE THE SVG BELOW ONCE WE FIX ISSUE WITH PATH ON PROD -->
              <svg width="67" height="81" viewBox="0 0 67 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="63" height="77" rx="4" stroke="white" stroke-width="4" />
                <path d="M8.8 12.33H10.46C11.0467 12.33 11.4833 12.3533 11.77 12.4C12.0567 12.44 12.3167 12.5233 12.55 12.65C12.85 12.81 13.0833 13.0433 13.25 13.35C13.4167 13.65 13.5 13.9933 13.5 14.38C13.5 15.2533 13.1067 15.87 12.32 16.23L13.85 19H12.36L11 16.45H10.08V19H8.8V12.33ZM10.08 15.36H10.54C11.0733 15.36 11.4367 15.3233 11.63 15.25C12.0033 15.1033 12.19 14.81 12.19 14.37C12.19 14.0167 12.05 13.7567 11.77 13.59C11.6433 13.5167 11.5 13.47 11.34 13.45C11.1867 13.43 10.89 13.42 10.45 13.42H10.08V15.36ZM15.9784 15H18.6284V16.09H15.9784V17.91H18.9984V19H14.6984V12.33H18.8884V13.42H15.9784V15ZM24.9195 14.5H23.8095C23.6762 13.7067 23.2629 13.31 22.5695 13.31C22.0762 13.31 21.6829 13.5233 21.3895 13.95C21.1029 14.3767 20.9595 14.9533 20.9595 15.68C20.9595 16.4 21.1062 16.9733 21.3995 17.4C21.6929 17.82 22.0862 18.03 22.5795 18.03C23.3529 18.03 23.7795 17.53 23.8595 16.53H24.9995C24.9195 18.2633 24.1295 19.13 22.6295 19.13C21.8295 19.13 21.1562 18.8767 20.6095 18.37C19.9562 17.75 19.6295 16.8567 19.6295 15.69C19.6295 14.4567 19.9829 13.5233 20.6895 12.89C21.2095 12.43 21.8362 12.2 22.5695 12.2C23.2762 12.2 23.8329 12.4 24.2395 12.8C24.6462 13.2 24.8729 13.7667 24.9195 14.5ZM27.4887 12.33H28.7887L31.0587 19H29.7287L29.3187 17.61H26.9687L26.5487 19H25.2387L27.4887 12.33ZM28.9987 16.52L28.1387 13.8L27.2887 16.52H28.9987ZM31.9543 12.33H33.6143C34.201 12.33 34.6376 12.3533 34.9243 12.4C35.211 12.44 35.471 12.5233 35.7043 12.65C36.0043 12.81 36.2376 13.0433 36.4043 13.35C36.571 13.65 36.6543 13.9933 36.6543 14.38C36.6543 15.2533 36.261 15.87 35.4743 16.23L37.0043 19H35.5143L34.1543 16.45H33.2343V19H31.9543V12.33ZM33.2343 15.36H33.6943C34.2276 15.36 34.591 15.3233 34.7843 15.25C35.1576 15.1033 35.3443 14.81 35.3443 14.37C35.3443 14.0167 35.2043 13.7567 34.9243 13.59C34.7976 13.5167 34.6543 13.47 34.4943 13.45C34.341 13.43 34.0443 13.42 33.6043 13.42H33.2343V15.36Z" fill="white" />
                <path d="M41.829 15.626H41.339C41.2083 15.0147 40.8537 14.709 40.275 14.709C39.8597 14.709 39.5283 14.8863 39.281 15.241C39.0383 15.591 38.917 16.067 38.917 16.669C38.917 17.2757 39.0383 17.754 39.281 18.104C39.5237 18.4493 39.8573 18.622 40.282 18.622C40.6087 18.622 40.8677 18.5193 41.059 18.314C41.255 18.1087 41.3717 17.81 41.409 17.418H41.906C41.864 17.95 41.703 18.3607 41.423 18.65C41.1477 18.9393 40.7743 19.084 40.303 19.084C39.7057 19.084 39.232 18.867 38.882 18.433C38.532 17.999 38.357 17.4157 38.357 16.683C38.357 15.9457 38.532 15.3553 38.882 14.912C39.232 14.4687 39.6987 14.247 40.282 14.247C40.716 14.247 41.066 14.3683 41.332 14.611C41.6027 14.849 41.7683 15.1873 41.829 15.626ZM43.3243 16.34H45.5153V14.331H46.0403V19H45.5153V16.774H43.3243V19H42.7993V14.331H43.3243V16.34ZM47.7608 16.354H49.6508V16.809H47.7608V18.545H49.8468V19H47.2358V14.331H49.7978V14.786H47.7608V16.354ZM53.9765 15.626H53.4865C53.3558 15.0147 53.0011 14.709 52.4225 14.709C52.0071 14.709 51.6758 14.8863 51.4285 15.241C51.1858 15.591 51.0645 16.067 51.0645 16.669C51.0645 17.2757 51.1858 17.754 51.4285 18.104C51.6711 18.4493 52.0048 18.622 52.4295 18.622C52.7561 18.622 53.0151 18.5193 53.2065 18.314C53.4025 18.1087 53.5191 17.81 53.5565 17.418H54.0535C54.0115 17.95 53.8505 18.3607 53.5705 18.65C53.2951 18.9393 52.9218 19.084 52.4505 19.084C51.8531 19.084 51.3795 18.867 51.0295 18.433C50.6795 17.999 50.5045 17.4157 50.5045 16.683C50.5045 15.9457 50.6795 15.3553 51.0295 14.912C51.3795 14.4687 51.8461 14.247 52.4295 14.247C52.8635 14.247 53.2135 14.3683 53.4795 14.611C53.7501 14.849 53.9158 15.1873 53.9765 15.626ZM57.3687 14.331H58.0057L56.1017 16.536L58.1877 19H57.4737L55.4787 16.55L57.3687 14.331ZM54.9467 14.331H55.4717V19H54.9467V14.331Z" fill="white" />
                <rect x="26" y="29" width="32" height="3" rx="0.5" fill="white" />
                <rect x="26" y="39" width="32" height="3" rx="0.5" fill="white" />
                <rect x="26" y="49" width="32" height="3" rx="0.5" fill="white" />
                <g clip-path="url(#clip0_1682_11027)">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 28.8566C10.5692 28.8333 10.8906 28.7657 11.9967 30.2815C12.845 28.708 13.7877 27.346 14.808 26.1578C15.8125 24.9876 15.8203 24.9847 17 25.0044C14.9928 27.5004 13.3548 30.1708 12.0448 33.0002C11.3437 31.3197 10.3645 29.9049 9 28.8566Z" fill="#5BC2F4" />
                </g>
                <g clip-path="url(#clip1_1682_11027)">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 38.8566C10.5692 38.8333 10.8906 38.7657 11.9967 40.2815C12.845 38.708 13.7877 37.346 14.808 36.1578C15.8125 34.9876 15.8203 34.9847 17 35.0044C14.9928 37.5004 13.3548 40.1708 12.0448 43.0002C11.3437 41.3197 10.3645 39.9049 9 38.8566Z" fill="#5BC2F4" />
                </g>
                <path d="M15.1725 52.5827C15.2819 52.7194 15.2682 52.9245 15.1315 53.0475C15.0632 53.1022 14.9948 53.1159 14.9264 53.1159C14.8307 53.1159 14.735 53.0885 14.6667 53.0065L12.6296 50.5729L10.5788 53.0065C10.5104 53.0885 10.4147 53.1159 10.319 53.1159C10.2507 53.1159 10.1823 53.1022 10.1139 53.0475C9.97721 52.9245 9.96354 52.7194 10.0729 52.5827L12.1921 50.0534L10.0729 47.5378C9.96354 47.401 9.97721 47.196 10.1139 47.0729C10.2507 46.9635 10.4557 46.9772 10.5788 47.1139L12.6296 49.5475L14.6667 47.1139C14.7897 46.9772 14.9948 46.9635 15.1315 47.0729C15.2682 47.196 15.2819 47.401 15.1725 47.5378L13.0534 50.0534L15.1725 52.5827Z" fill="#5BC2F4" />
                <defs>
                  <clipPath id="clip0_1682_11027">
                    <rect width="8" height="8" fill="white" transform="translate(9 25)" />
                  </clipPath>
                  <clipPath id="clip1_1682_11027">
                    <rect width="8" height="8" fill="white" transform="translate(9 35)" />
                  </clipPath>
                </defs>
              </svg>

              <p>140 punkts tjek</p>
            </div>
            <div>
              <!-- TODO: REMOVE THE SVG BELOW ONCE WE FIX ISSUE WITH PATH ON PROD -->
              <!-- <img src="/assets/listing/search-car.png" /> -->
              <svg width="104" height="102" viewBox="0 0 104 102" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g filter="url(#filter0_d_1173_6028)">
                  <rect x="4" width="96" height="94" fill="url(#pattern0)" shape-rendering="crispEdges" />
                </g>
                <defs>
                  <filter id="filter0_d_1173_6028" x="0" y="0" width="104" height="102" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1173_6028" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1173_6028" result="shape" />
                  </filter>
                  <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlink:href="#image0_1173_6028" transform="matrix(0.00652778 0 0 0.00666667 -0.707639 0)" />
                  </pattern>
                  <image
                    id="image0_1173_6028"
                    width="370"
                    height="150"
                    xlink:href="data:image/png;base64,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"
                  />
                </defs>
              </svg>

              <p>Uafhængig gennemgang af ekstern mekaniker</p>
            </div>
            <div>
              <div>
                <!-- TODO: REMOVE THE SVG BELOW ONCE WE FIX ISSUE WITH PATH ON PROD -->
                <!-- <img src="/assets/listing/form-check.png" /> -->
                <svg width="67" height="81" viewBox="0 0 67 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="2" width="63" height="77" rx="4" stroke="white" stroke-width="4" />
                  <path d="M8.8 12.33H10.46C11.0467 12.33 11.4833 12.3533 11.77 12.4C12.0567 12.44 12.3167 12.5233 12.55 12.65C12.85 12.81 13.0833 13.0433 13.25 13.35C13.4167 13.65 13.5 13.9933 13.5 14.38C13.5 15.2533 13.1067 15.87 12.32 16.23L13.85 19H12.36L11 16.45H10.08V19H8.8V12.33ZM10.08 15.36H10.54C11.0733 15.36 11.4367 15.3233 11.63 15.25C12.0033 15.1033 12.19 14.81 12.19 14.37C12.19 14.0167 12.05 13.7567 11.77 13.59C11.6433 13.5167 11.5 13.47 11.34 13.45C11.1867 13.43 10.89 13.42 10.45 13.42H10.08V15.36ZM15.9784 15H18.6284V16.09H15.9784V17.91H18.9984V19H14.6984V12.33H18.8884V13.42H15.9784V15ZM24.9195 14.5H23.8095C23.6762 13.7067 23.2629 13.31 22.5695 13.31C22.0762 13.31 21.6829 13.5233 21.3895 13.95C21.1029 14.3767 20.9595 14.9533 20.9595 15.68C20.9595 16.4 21.1062 16.9733 21.3995 17.4C21.6929 17.82 22.0862 18.03 22.5795 18.03C23.3529 18.03 23.7795 17.53 23.8595 16.53H24.9995C24.9195 18.2633 24.1295 19.13 22.6295 19.13C21.8295 19.13 21.1562 18.8767 20.6095 18.37C19.9562 17.75 19.6295 16.8567 19.6295 15.69C19.6295 14.4567 19.9829 13.5233 20.6895 12.89C21.2095 12.43 21.8362 12.2 22.5695 12.2C23.2762 12.2 23.8329 12.4 24.2395 12.8C24.6462 13.2 24.8729 13.7667 24.9195 14.5ZM27.4887 12.33H28.7887L31.0587 19H29.7287L29.3187 17.61H26.9687L26.5487 19H25.2387L27.4887 12.33ZM28.9987 16.52L28.1387 13.8L27.2887 16.52H28.9987ZM31.9543 12.33H33.6143C34.201 12.33 34.6376 12.3533 34.9243 12.4C35.211 12.44 35.471 12.5233 35.7043 12.65C36.0043 12.81 36.2376 13.0433 36.4043 13.35C36.571 13.65 36.6543 13.9933 36.6543 14.38C36.6543 15.2533 36.261 15.87 35.4743 16.23L37.0043 19H35.5143L34.1543 16.45H33.2343V19H31.9543V12.33ZM33.2343 15.36H33.6943C34.2276 15.36 34.591 15.3233 34.7843 15.25C35.1576 15.1033 35.3443 14.81 35.3443 14.37C35.3443 14.0167 35.2043 13.7567 34.9243 13.59C34.7976 13.5167 34.6543 13.47 34.4943 13.45C34.341 13.43 34.0443 13.42 33.6043 13.42H33.2343V15.36Z" fill="white" />
                  <path d="M41.829 15.626H41.339C41.2083 15.0147 40.8537 14.709 40.275 14.709C39.8597 14.709 39.5283 14.8863 39.281 15.241C39.0383 15.591 38.917 16.067 38.917 16.669C38.917 17.2757 39.0383 17.754 39.281 18.104C39.5237 18.4493 39.8573 18.622 40.282 18.622C40.6087 18.622 40.8677 18.5193 41.059 18.314C41.255 18.1087 41.3717 17.81 41.409 17.418H41.906C41.864 17.95 41.703 18.3607 41.423 18.65C41.1477 18.9393 40.7743 19.084 40.303 19.084C39.7057 19.084 39.232 18.867 38.882 18.433C38.532 17.999 38.357 17.4157 38.357 16.683C38.357 15.9457 38.532 15.3553 38.882 14.912C39.232 14.4687 39.6987 14.247 40.282 14.247C40.716 14.247 41.066 14.3683 41.332 14.611C41.6027 14.849 41.7683 15.1873 41.829 15.626ZM43.3243 16.34H45.5153V14.331H46.0403V19H45.5153V16.774H43.3243V19H42.7993V14.331H43.3243V16.34ZM47.7608 16.354H49.6508V16.809H47.7608V18.545H49.8468V19H47.2358V14.331H49.7978V14.786H47.7608V16.354ZM53.9765 15.626H53.4865C53.3558 15.0147 53.0011 14.709 52.4225 14.709C52.0071 14.709 51.6758 14.8863 51.4285 15.241C51.1858 15.591 51.0645 16.067 51.0645 16.669C51.0645 17.2757 51.1858 17.754 51.4285 18.104C51.6711 18.4493 52.0048 18.622 52.4295 18.622C52.7561 18.622 53.0151 18.5193 53.2065 18.314C53.4025 18.1087 53.5191 17.81 53.5565 17.418H54.0535C54.0115 17.95 53.8505 18.3607 53.5705 18.65C53.2951 18.9393 52.9218 19.084 52.4505 19.084C51.8531 19.084 51.3795 18.867 51.0295 18.433C50.6795 17.999 50.5045 17.4157 50.5045 16.683C50.5045 15.9457 50.6795 15.3553 51.0295 14.912C51.3795 14.4687 51.8461 14.247 52.4295 14.247C52.8635 14.247 53.2135 14.3683 53.4795 14.611C53.7501 14.849 53.9158 15.1873 53.9765 15.626ZM57.3687 14.331H58.0057L56.1017 16.536L58.1877 19H57.4737L55.4787 16.55L57.3687 14.331ZM54.9467 14.331H55.4717V19H54.9467V14.331Z" fill="white" />
                  <rect x="26" y="29" width="32" height="3" rx="0.5" fill="white" />
                  <rect x="26" y="39" width="32" height="3" rx="0.5" fill="white" />
                  <rect x="26" y="49" width="32" height="3" rx="0.5" fill="white" />
                  <g clip-path="url(#clip0_1682_11027)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 28.8566C10.5692 28.8333 10.8906 28.7657 11.9967 30.2815C12.845 28.708 13.7877 27.346 14.808 26.1578C15.8125 24.9876 15.8203 24.9847 17 25.0044C14.9928 27.5004 13.3548 30.1708 12.0448 33.0002C11.3437 31.3197 10.3645 29.9049 9 28.8566Z" fill="#5BC2F4" />
                  </g>
                  <g clip-path="url(#clip1_1682_11027)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 38.8566C10.5692 38.8333 10.8906 38.7657 11.9967 40.2815C12.845 38.708 13.7877 37.346 14.808 36.1578C15.8125 34.9876 15.8203 34.9847 17 35.0044C14.9928 37.5004 13.3548 40.1708 12.0448 43.0002C11.3437 41.3197 10.3645 39.9049 9 38.8566Z" fill="#5BC2F4" />
                  </g>
                  <path d="M15.1725 52.5827C15.2819 52.7194 15.2682 52.9245 15.1315 53.0475C15.0632 53.1022 14.9948 53.1159 14.9264 53.1159C14.8307 53.1159 14.735 53.0885 14.6667 53.0065L12.6296 50.5729L10.5788 53.0065C10.5104 53.0885 10.4147 53.1159 10.319 53.1159C10.2507 53.1159 10.1823 53.1022 10.1139 53.0475C9.97721 52.9245 9.96354 52.7194 10.0729 52.5827L12.1921 50.0534L10.0729 47.5378C9.96354 47.401 9.97721 47.196 10.1139 47.0729C10.2507 46.9635 10.4557 46.9772 10.5788 47.1139L12.6296 49.5475L14.6667 47.1139C14.7897 46.9772 14.9948 46.9635 15.1315 47.0729C15.2682 47.196 15.2819 47.401 15.1725 47.5378L13.0534 50.0534L15.1725 52.5827Z" fill="#5BC2F4" />
                  <defs>
                    <clipPath id="clip0_1682_11027">
                      <rect width="8" height="8" fill="white" transform="translate(9 25)" />
                    </clipPath>
                    <clipPath id="clip1_1682_11027">
                      <rect width="8" height="8" fill="white" transform="translate(9 35)" />
                    </clipPath>
                  </defs>
                </svg>

                <p>Uddybende rapport af eventuelle fejl</p>
              </div>
            </div>
          </div>
          <h3>Speciel pris DKK 1.195 - ekskl. moms</h3>
          <p>Kontrollen foretages hos STARMARK</p>
          <a href="https://www.recar.dk/">BESTIL HER</a>
        </div>
      </div>
    </div>
    <Brochure v-if="details && !loading" :details="details" :qr-code-url="url" />
    <Drawer :direction="'right'" :exist="true" ref="RightDrawer">
      <seez-sdk-trade-in :policy-url="policyUrl" ref="tradeIn" :listing="$route.params.id" :search-vehicle="licensePlateToSearch" @close-drawer="clickTradeIn" @on-click-view-tradeins="goToMyTradeins" lg="da" />
    </Drawer>
    <Loader v-if="loading" />
    <seez-sdk-test-drive-modal :policy-url="policyUrl" ref="testDriveModal" :listing-id="details.id" @click-test-drive="showTestDriveModal = true" @close="showTestDriveModal = false" v-if="showTestDriveModal" lg="da">
      <ModalInfoFooter :reference-number="details.referenceNumber" />
    </seez-sdk-test-drive-modal>
  </div>
</template>
<script>
import { querier } from '../../lib/querierMixin'
import WholesaleBanner from '../../components/WholesaleBanner.vue'
import ImageGrid from './ImageGrid.vue'
import ListingInfo from './ListingInfo.vue'
import Specs from './SpecsComponent.vue'
import ToggleSpecsList from './ToggleSpecsList.vue'
import BenefitsHeader from './BenefitsHeader.vue'
import TradeInBanner from './TradeInBanner.vue'
import VideoBanner from './VideoBanner.vue'
import Benefits from './BenefitsComponent.vue'
import Drawer from './DrawerComponent.vue'
import Brochure from './BrochureComponent.vue'
import ModalInfoFooter from './ModalInfoFooter.vue'
import ModelsInfoBanner from './ModelsInfoBanner.vue'
import Loader from '../../components/LoaderComponent.vue'
import ErrorMessage from './Error.vue'
import { LISTING } from '../../lib/constants'
import { ROUTES } from '../../router'
import { formatSpec } from '../../lib/helper'

export default {
  name: 'ListingPage',
  components: {
    WholesaleBanner,
    BenefitsHeader,
    ImageGrid,
    ListingInfo,
    TradeInBanner,
    ModelsInfoBanner,
    VideoBanner,
    Benefits,
    Specs,
    ToggleSpecsList,
    Drawer,
    Brochure,
    ModalInfoFooter,
    Loader,
    ErrorMessage
  },
  mixins: [querier],
  data() {
    return {
      dataSeller: 80,
      details: null,
      loading: false,
      error: null,
      licensePlateToSearch: '',
      noRelated: false,
      url: window.location.href,
      showTestDriveModal: false,
      loanCalculation: null,
      hasSliderOffers: true,
      relatedTotal: 0
    }
  },
  computed: {
    hasRetailPrice() {
      return this.details?.retailPrice?.value
    },
    cardStyles() {
      return {
        '--card-height': this.wholesale ? '24.5rem' : '27.5rem',
        '--card-financing-display': this.wholesale ? 'none' : 'flex',
        '--card-leasing-display': this.wholesale ? 'none' : 'flex'
      }
    },
    policyUrl() {
      return '/persondata-politik'
    },
    t() {
      return LISTING
    },
    sameModelFilter() {
      return `?models=${this.details?.model?.id}`
    },
    relatedFilter() {
      if (this.$route.params.id == null) return null
      else return `?related-to=${this.$route.params.id}`
    },
    formatSpec() {
      return formatSpec
    },
    wholesale() {
      return this.details?.wholesalePrice?.value != null
    },
    hasLeasePrice() {
      return Boolean(this.details?.leasePrice?.value || this.details?.wholesaleLeasePrice?.value)
    }
  },
  watch: {
    '$route.params.id'() {
      this.loadDetails()
    },
    onHide() {
      this.loading = false
    },
    details() {
      this.$nextTick(() => {
        this.checkForHash()
      })
    },
    showTestDriveModal() {
      this.$root.track(this.$root.events.CTA_CLICK, { properties: { event_label: 'show_test_drive_modal' } })
    }
  },
  created() {
    this.loadDetails()
    this.calculateLoan()
    const forceRefresh = null
    const track = false
    window.seezSdk.getCurrentUser(forceRefresh, track).then(r => {
      this.user = r

      if (this.$route.query['show-tradein']) {
        if (r) this.showTradeInOffer(parseInt(this.$route.query['show-tradein']))
        else {
          // this.$root.showLogin()
          window.seezSdk.showLogin(null, true, {
            branding: '<div class="branding">&nbsp;</div>'
          })
        }
      }
    })
  },
  methods: {
    getModelSlug(listing) {
      const text = `${listing.model.name} ${listing.variant}`

      return this.$root.slugify(text)
    },
    clickPayment(e) {
      const selectedPaymentType = e.detail[0].type
      const listing = e.detail[0].listing

      if (selectedPaymentType === 'financing') {
        const brand = this.$root.slugify(listing.model.family.brand.name)
        const modelSlug = this.getModelSlug(listing)
        window.location = `/biler/${brand}/${modelSlug}/${listing.id}/#calc`
        return
      }
      this.popupLeadModal()
    },
    popupLeadModal() {
      window.seezSdk.showModal('seez-sdk-lead-form', { listing: this.$route.params.id }, true)
      this.$root.track(this.$root.events.CTA_CLICK, { properties: { event_label: 'show_lead_modal' } })
    },
    checkForHash() {
      if (this.$route.hash === '#calc') {
        this.$refs.calculator.scrollIntoView({ behavior: 'smooth' })
      }
    },
    onHide() {
      this.hideSession = false
    },
    scrollTo(reference) {
      if (reference && this?.$refs[reference]) return this.$refs[reference].scrollIntoView({ behavior: 'smooth' })
      if (this.wholesale) return this.$refs.wholesaleBanner.scrollIntoView({ behavior: 'smooth' })
      return this.$refs.calculator.scrollIntoView({ behavior: 'smooth' })
    },
    clickBuy() {
      this.$root.track(this.$root.events.ADD_TO_CART, {
        properties: { type: 'listing_page' },
        event_label: { car_id: this.details.id },
        listing_id: parseInt(this.details.id)
      })
      this.validation()
    },
    async calculateLoan() {
      this.loading = true
      try {
        const listingId = parseInt(this.$route.params.id)
        if (!(listingId > 0)) throw new Error('Invalid listing id: ' + this.$route.params.id)
        const result = await this.queryApi(`{loanCalculation(listingId:${listingId}, paymentTerms:96){ monthlyPayment disclaimer paymentTerms }}`)
        this.loanCalculation = result.loanCalculation
      } catch (error) {
        this.loanCalculation = null
      } finally {
        this.loading = false
      }
    },
    async validation() {
      const isReserved = this.details.state !== 'available' || this.details.reservedBy != null
      this.loading = true
      const currentUser = await window.seezSdk.getCurrentUser()
      if (currentUser) {
        this.loading = true
        const { user } = await this.queryApi('{user{activeOrder{id, state, listingId}, orders {id, listingId, state}}}')
        this.loading = false

        if (this.details.reservedBy === currentUser.id) {
          const order = user.activeOrder ?? user.orders.find(o => o.listingId === this.details.id.toString() && o.state === 'confirmed')
          // eslint-disable-next-line require-atomic-updates
          window.location = `${window.location.origin}${ROUTES.CHECKOUT}/?order=${order.id}`
          return
        } else if (user.activeOrder && !isReserved) {
          const decision = await window.seezSdk.confirmCancelOrder(user.activeOrder.listingId, this.$root.cardPlaceholder)
          // eslint-disable-next-line require-atomic-updates
          if (decision === 'ResumeCurrent') window.location = `${window.location.origin}${ROUTES.CHECKOUT}/?order=${user.activeOrder.id}`
          if (decision === 'CancelAndStartNew') {
            this.loading = true
            await this.queryApi(`mutation {cancelOrder(orderId: ${user.activeOrder.id}) {id} }`)
            this.loading = false
            this.$router.push({ path: `${ROUTES.INTRO}/${this.$route.params.id}` })
          }
          return
        }
      }
      if (isReserved) {
        window.seezSdk.showUnavailableListingModal('/soegeresultater/', this.$route.params.id, '/biler/{brand}/{model}/{id}', `/soegeresultater/?related-to=${this.$route.params.id}`)
        this.loading = false
      } else this.$router.push({ path: `${ROUTES.INTRO}/${this.$route.params.id}` })
    },
    async loadDetails() {
      this.loading = true
      this.error = null
      try {
        const query = `
          query listingDetails($listingId: ID) {
            listing(id: $listingId) {
              id name model {id name family { id name brand {id name}}} bodyType { name } targetSite { name logo brandingHighlightColor }
              variant year currency kilometrage dealership {id name description logoUrl financing {logo}}
              images color batterySize hp transmission {name} fuelType {id name} registrationDate state reservedBy
              equipment { design comfort safety uncategorized} referenceNumber acceleration numAirbags numGears numCylinders
              weight loadCapacity maxAttachment numDoors fuelConsumption range description locatedAt { plainAddress }
              typeName leasePrice { value currency lease { duration downPayment residualValue type audience }}
              wholesaleLeasePrice{ value currency lease { duration downPayment residualValue type audience }}
              retailPrice { value currency disclaimer } emiPrice { value currency } wholesalePrice { value currency}
              videos greenTax batteryConsumption topSpeed torque
            }
          }`
        const listingId = parseInt(this.$route.params.id)
        if (!(listingId > 0)) throw new Error('Invalid listing id: ' + this.$route.params.id)
        const result = await this.queryApi(query, { listingId })
        this.details = result.listing
        const listingSEO = this.getListingSEO()
        this.$root.setPageTitle(listingSEO.title, listingSEO.description)

        // Embed the external script, in order to load the offer-sliders.js
        // It must be appended here as it depends on the existance of the this.details object.
        this.embedFindLeasingSliderOffersScript()
      } catch (err) {
        console.error(err)
        this.error = err.message ?? err
      } finally {
        this.loading = false
      }
    },
    embedFindLeasingSliderOffersScript() {
      const offerEmbedScript = document.createElement('script')
      offerEmbedScript.setAttribute('src', 'https://www.findleasing.nu/offer-sliders.js')
      document.head.appendChild(offerEmbedScript)
      // Hide the element and only set the hasSliderOffers to true, if the message event gets the init cmd
      this.hasSliderOffers = false
      window.addEventListener('message', this.receiveFindLeasingMessage, false)
    },
    isFindLeasingData(s, identifier) {
      return s.substr(0, identifier.length) === identifier
    },
    receiveFindLeasingMessage(evt) {
      // Set the hasSliderOffers to true, if the message event gets the init cmd
      const identifier = '[FindLeasing]'
      if (evt.origin !== 'https://www.findleasing.nu' || !this.isFindLeasingData(evt.data, identifier)) return
      let data = evt.data.substr(identifier.length, evt.data.length).split(':')
      let cmd = data[0]
      if (cmd === 'init') this.hasSliderOffers = true
    },
    getPrice() {
      const d = this.details
      const priceValue = d.wholesalePrice?.value ?? d.retailPrice?.value ?? d.leasePrice?.value
      const priceString = this.$root.formatNumber(priceValue, 0, d.currency)
      const suffix = d.wholesalePrice?.value ?? d.retailPrice?.value == null ? ' / md' : ''
      return priceString + suffix
    },
    getListingSEO() {
      const price = this.getPrice()
      const modelVariant = `${this.details.model.name}  ${this.details.variant}`
      const brand = this.details.model.family.brand.name === 'Mercedes' ? 'Mercedes-Benz' : this.details.model.family.brand.name
      const title = `${price} | ${modelVariant} - ${this.details.color} | ${brand} | Starmark `
      const description = `Køb ${brand} ${modelVariant} fra ${this.details.year} i ${this.details.color} på Starmark ✓ Pris:${price} ✓ Se specifikationer og fotos online`
      return { title, description }
    },
    clickTradeIn(inputValue) {
      this.$root.track(this.$root.events.CTA_CLICK, { properties: { type: 'trade_in_listing_page' } })

      if (this.$refs.RightDrawer.active) {
        this.$refs.RightDrawer.close()
      } else {
        this.licensePlateToSearch = inputValue
        this.$refs.RightDrawer.open()
      }
    },
    goToMyTradeins() {
      this.$router.push('/min/byttebil')
    },
    relatedLoaded(e) {
      const total = e.detail[0]?.total
      if (total <= 1) this.noRelated = true
      this.relatedTotal = total
    },
    goToCar(e) {
      e.detail[0].preventDefault()
      const { item: listing } = e.detail[1]
      const brand = this.$root.slugify(listing.model.family.brand.name)
      const modelSlug = this.getModelSlug(listing)
      this.$router.push({ path: `/biler/${brand}/${modelSlug}/${listing.id}` })
    },
    showTradeInOffer(id) {
      let promiseResolve = null

      function closed() {
        document.body.querySelectorAll('seez-sdk-tradein-offer').forEach(x => x.parentNode.removeChild(x))
        if (promiseResolve) promiseResolve()
      }

      function checkListing(e) {
        if (e.detail[0].listing.id !== this.$route.params.id) closed()
      }

      const tradeinOfferComponent = document.createElement('seez-sdk-tradein-offer')
      tradeinOfferComponent.setAttribute('tradein', id)
      document.body.appendChild(tradeinOfferComponent)
      tradeinOfferComponent.addEventListener('loaded', checkListing.bind(this))
      tradeinOfferComponent.addEventListener('close', closed.bind(this))
      tradeinOfferComponent.addEventListener('buy', this.clickBuy)
      tradeinOfferComponent.addEventListener('buy', closed.bind(this))

      // eslint-disable-next-line no-unused-vars
      return new Promise(function (resolve, reject) {
        promiseResolve = resolve
      }, false)
    },
    leadModalTrackEvent(e) {
      if (e?.detail) {
        const event = e.detail[0]
        const eventName = event[0]
        const properties = event[1]
        this.$root.track(eventName, properties)
      }
    }
  }
}
</script>
<style lang="scss">
@import '../../styles/base.scss';

.invisible {
  opacity: 0;
}

.benefitsHeaderWrapper {
  padding-top: 5.5rem;

  @include respond(st-48) {
    padding-top: 0;
  }
}

seez-sdk-lead-form {
  .leadForm {
    padding: 0;
    margin: 0;

    .detail-showroom {
      display: none;
    }
    .formWrapper {
      padding: 0;
      box-shadow: none;

      .headingWrapper {
        border: none;
        margin: 0;
        padding: 0;
        padding-top: 1rem;

        .headingHidden {
          display: block;
        }
      }
      form {
        :nth-child(4) {
          display: none;
        }
        :nth-child(5) {
          grid-column: span 6 / span 6;
        }
        :nth-child(6) {
          grid-column: span 6 / span 6;
          @media screen and (min-width: 40rem) {
            grid-column: span 3 / span 3;
          }
        }
        :nth-child(7) {
          grid-column: span 6 / span 6;
          @media screen and (min-width: 40rem) {
            grid-column: span 3 / span 3;
          }
        }
      }
    }
  }
}

.listingContainer {
  min-height: 100vh;
  overflow: auto;
  background-color: var(--var(--white));
  margin-top: 5.8rem;
  width: 100%;
  overflow-x: hidden;
  margin: auto;

  .customInfo {
    margin-top: 1.88rem;
  }

  @include respond(st-48) {
    margin-top: 0;
  }

  .layout {
    padding: 1rem;
    max-width: 80rem;
    margin: auto;

    @media screen and (min-width: 96rem) {
      margin-top: 2.438rem;
      max-width: 85rem;
    }

    .errorWrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  > .bottomSession {
    @media print {
      display: none;
    }
    .wholesaleBannerWrapper {
      max-width: 85rem;
      margin: 3.438rem auto;

      .wholesaleBanner {
        background-color: #252525;
        border-radius: 32px;
        color: var(--white);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 3rem 0;

        > h2 {
          font-family: var(--font-heading);
          font-weight: 400;
          font-size: 1.5rem;
          text-align: center;
          line-height: 40px;

          @include respond(st-48) {
            font-size: 2.25rem;
          }
        }

        > .flexIcons {
          display: flex;
          flex-direction: column;
          width: 100%;
          gap: 1rem;
          margin-top: 1rem;

          @include respond(st-48) {
            flex-direction: row;
            max-width: 80%;
          }

          div {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            min-height: 12rem;

            p {
              text-align: center;
              min-height: 2rem;
              max-width: auto;
              margin-top: 1rem;

              @media only screen and (min-width: 55rem) {
                max-width: 70%;
              }
            }
          }
        }

        > h3 {
          font-family: var(--font-heading);
          font-weight: 400;
          font-size: 1.625rem;
          line-height: 29px;
          margin-top: 2.563rem;
        }

        > p {
          font-family: var(--font-family);
          font-weight: 400;
          font-size: 1rem;
          line-height: 24px;
        }

        > a {
          background-color: var(--highlight);
          border-radius: 12px;
          color: var(--white);
          font-family: var(--font-family);
          max-width: 16.875rem;
          margin-top: 2.313rem;
          padding: 0.626rem 5.938rem;
          cursor: pointer;
          text-decoration: none;

          &:hover {
            opacity: 0.75;
          }
        }
      }
    }
    .related {
      max-width: 68.2rem;
      margin: auto;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;

      > h2 {
        padding: 0;
        margin: 3.5rem 0 1.875rem 0;
        color: var(--black);
        font-family: var(--font-heading);
        font-size: 2rem;
        font-weight: 100;

        @include respond(st-48) {
          font-size: 2.25rem;
        }
      }

      > a {
        border-radius: 12px;
        color: var(--white);
        background-color: var(--highlight);
        width: fit-content;
        padding: 0.75rem 3rem;
        margin-top: 1.25rem;
        font-weight: 700;
        cursor: pointer;
        text-decoration: none;
        font-family: var(--font-family);
        text-transform: uppercase;
      }
    }

    span > .calculator {
      padding: 1rem;
      border-radius: 16px;
      margin: 2rem auto;
      background-color: #f5f5f5;

      @include respond(st-48) {
        border-radius: 0;
      }

      > div {
        max-width: 80rem;
        margin: 0 auto;

        .calculatorParagraph {
          padding: 1rem 0 1.5rem 0;
        }
      }
    }
  }

  .listingDetails {
    color: var(--dark-gray-80);
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: auto;
    grid-template-areas:
      'imageWrapper imageWrapper cta'
      'mainDetailsWrapper mainDetailsWrapper mainDetailsWrapper'
      'dealerdescription dealerdescription dealerdescription'
      'specs specs specs'
      'tradeIn tradeIn tradeIn'
      'videoBanner videoBanner videoBanner'
      'related related related';
    position: relative;

    @media screen and (max-width: 50rem) {
      grid-template-columns: 1fr;
      grid-template-rows: repeat(7, auto) 1fr;
      grid-template-areas:
        'imageWrapper'
        'cta'
        'mainDetailsWrapper'
        'dealerdescription'
        'specs'
        'tradeIn'
        'videoBanner'
        'benefits'
        'calculator'
        'related';

      > .specs {
        > details {
          grid-template-columns: 1fr;
          gap: 1em;
          padding: 1em 0;

          > dl {
            grid-template-columns: 1fr 1fr;
            margin: 1em 0;

            > dt:nth-of-type(2n) {
              margin-left: 0;
            }

            > dd:nth-of-type(2n + 1) {
              margin-right: 0;
            }
          }

          > ul {
            grid-template-columns: 1fr;
            margin: 1em 0;
          }

          > div {
            margin: 0;
          }
        }
      }
    }

    @media print {
      display: none;
    }
  }
}

// start styles for trade-in
seez-sdk-trade-in {
  @media print {
    display: none;
  }

  .tradeInDrawerContainer {
    --highlight: #5bc2f4;

    .multiselect {
      > ul {
        left: -1rem;
      }
    }
    @mixin input-width {
      min-width: 10rem;
      max-width: 10rem;
    }

    * {
      font-family: var(--font-family) !important;
    }

    *input {
      border-radius: 12px !important;
    }

    *button {
      border-radius: 12px !important;
    }

    > button:last-of-type {
      background-color: #5bc2f4 !important;
    }

    .conditionDetails {
      border-radius: 12px;
    }

    .carDetails {
      display: grid;
      grid-template-columns: 1fr;
      gap: 14px;

      @include respond(st-48) {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }

    .doubleColumn {
      grid-column-end: span 3;
    }

    .questionWrapper {
      @include respond(st-48) {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .radio-btn-group {
        @include respond(st-48) {
          @include input-width;
        }
      }

      .carDetails input {
        @include respond(st-48) {
          @include input-width;
        }
      }

      .carDetails .multiselect {
        @include respond(st-48) {
          @include input-width;
        }
      }

      .multiselect {
        @include respond(st-48) {
          @include input-width;
        }
      }
    }

    .uploadSection {
      background: #f5f5f5 !important;
      border: 1px dashed black !important;
      cursor: pointer;

      svg {
        path {
          fill: black;
        }
      }

      label.tradeInImagesLabel {
        text-decoration: underline;
        color: #5bc2f4;
        cursor: pointer !important;
      }
    }

    .privacyBox {
      margin-top: 1rem;
      label {
        margin-inline-start: 0.3rem;
      }

      label:first-of-type {
        display: none;
      }
      label.customTermsLabel:before {
        content: 'Ja tak, jeg vil gerne holdes opdateret af STARMARK I/S via telefon, e-mail og SMS om biler, tilbehør og ydelser til biler, reparation/service af biler, events og konkurrencer STARMARK I/S må kontakte mig for udvidelse af samtykket. Du kan til enhver tid tilbagekalde dit samtykke på info@starmark.dk';
      }

      label.customPrivacyLabel {
        &:before {
          content: 'Jeg accepterer vilkårene ';
        }

        a {
          color: black;

          &:before {
            content: 'persondatapolitikken';
          }
        }
      }
    }

    .getTradeInValue {
      &:disabled {
        background: rgba(91, 194, 244, 0.5);
        cursor: not-allowed;
      }
    }
  }

  .tradeInDrawerContainer .radio-btn-group .radio label {
    border-radius: 12px !important;
  }

  .tradeInDrawerContainer > .relativePositioned > .tradeInTitle h2 {
    font-family: var(--font-heading) !important;
    font-style: normal;
    font-weight: 400;
    font-size: 2.188rem;
    line-height: 2.438rem;
  }

  .tradeInDrawerContainer .licensePlate {
    border-radius: 12px !important;
  }

  .tradeInDrawerContainer .licensePlate > span.prefix {
    border-radius: 12px 0 0 12px !important;
  }

  .tradeInDrawerContainer .licensePlate > button.search {
    border-radius: 12px;
  }
}
// end styles for trade-in

// start styles for tradein-help
seez-sdk-tradein-help {
  .tradeInUploadHelp {
    --highlight: #5bc2f4;
  }
}
// end styles for tradein-help

// start styles for seez-sdk-calculator
seez-sdk-calculator {
  --highlight: #5bc2f4;
  .calculatorWrapper {
    --highlight: #5bc2f4;
    * {
      font-family: var(--font-family) !important;
    }
  }

  .calculatorWrapper > .calculator > .leftContent > span > span {
    background-color: var(--highlight) !important;
  }
  .calculatorWrapper .calculator > .leftContent > label {
    font-weight: normal;
  }
  .calculatorWrapper .calculator > .leftContent > .loanDurationOptions > .active {
    border: 2px solid var(--highlight) !important;
    font-weight: 700;
    max-height: 2.8rem;
    color: var(--highlight) !important;
  }

  .calculatorWrapper .calculator > .leftContent > .checkboxMenu .active {
    border: 2px solid var(--highlight) !important;
  }

  .calculatorWrapper .calculator > .rightContent .blue-text {
    color: var(--highlight) !important;
  }

  .calculatorWrapper .loanDetailsHeader > .showLoanDetailsButton {
    color: var(--highlight) !important;
  }
}
// end styles for seez-sdk-calculator

// start styles for seez-sdk-carousel
seez-sdk-carousel {
  .listings > .listingCard {
    .name,
    .variant,
    .retail {
      text-align: left;
    }
    .prices {
      .emi,
      .lease {
        :nth-child(1) {
          text-align: left;
        }
      }
    }
    @include starmark-listing-card(var(--card-height), var(--card-financing-display), var(--card-leasing-display));
  }
}
// end styles for seez-sdk-carousel

// start styles for the seez-sdk-lead-modal
seez-sdk-lead-modal {
  @include starmark-lead-modal-style;
}
// end styles for seez-sdk-modal

// start styles for seez-sdk-active-order-cancellation
seez-sdk-active-order-cancellation {
  dialog > .cancelOrderDialog > .cta > button {
    border-radius: 12px;
    border: 1px solid #5bc2f4;
    font-family: var(--font-family);

    &:first-of-type {
      color: #5bc2f4;
    }

    &:last-of-type {
      background-color: #5bc2f4;
    }
  }
}
// end styles for seez-sdk-active-order-cancellation

// start styles for seez-test-drive-modal
seez-sdk-test-drive-modal {
  .seezModal {
    font-family: var(--font-family);
    background: #ffffff;
    border-radius: 0rem;
    max-width: 40rem;
    margin: auto;

    @include respond(st-48) {
      border-radius: 1rem;
    }

    .success {
      p {
        font-weight: 400;
      }

      button {
        background-color: var(--highlight);
        width: 100%;
        border-radius: 12px;
        padding: 0.75rem 1rem;
        color: white;
        border: none;
      }
    }

    > button {
      &:focus {
        outline: 0;
      }
    }

    > .testDriveModal {
      .headingText {
        border-bottom: 1px solid var(--light-gray);
        padding: 1rem 0;

        h2 {
          padding: 0;
          margin: 0 0 0.3rem 0;
          font-size: 2rem;
          font-family: var(--font-family);
          font-weight: normal;
          white-space: nowrap;
        }

        > div {
          white-space: nowrap;
          span:first-of-type {
            font-family: var(--font-family);
            font-weight: normal;
            font-size: 0.938rem;
          }
        }

        > div > span:nth-child(2) {
          font-size: 0.8rem;
          text-align: center;
          font-weight: normal;

          > svg {
            transform: translateY(0.1rem);
          }
        }
      }

      > div > .testDriveForm {
        p {
          margin: 0;
          padding: 0;
        }

        label {
          > span {
            display: none;
          }

          input[type='date'] {
            appearance: textfield;
            -moz-appearance: textfield;
            -webkit-appearance: none;
            color: black;
          }

          input {
            @include starmark-input-style;
            padding: 1rem 0.4rem 1rem 0;
          }

          @include black-placeholder;
        }

        .multiselectLabel {
          ul > li {
            font-family: var(--font-family);
          }
          > .multiselect {
            > div > button {
              background: #f5f5f5;
              border-radius: 0.875rem;
              padding: 1.05rem 0;
              border: none;
              text-indent: 0.625rem;
              font-size: 1rem;

              > span {
                font-family: var(--font-family);
              }

              > svg {
                transform: translateY(1rem);
              }
            }

            > div > ul {
              background-color: white;
            }
          }
        }

        .tradeInBtn {
          @include starmark-cta;
        }
      }

      .termsWrapper {
        .checkboxWrapper {
          display: flex;
          align-items: flex-start;
          margin-top: 1rem;
          font-size: 0.75rem;

          input {
            min-width: 5%;

            @include respond(st-48) {
              min-width: auto;
            }
          }

          label {
            margin-inline-start: 0.3rem;
          }

          label:first-of-type {
            display: none;
          }

          label.customTermsLabel:before {
            content: 'Ja tak, jeg vil gerne holdes opdateret af STARMARK I/S via telefon, e-mail og SMS om biler, tilbehør og ydelser til biler, reparation/service af biler, events og konkurrencer STARMARK I/S må kontakte mig for udvidelse af samtykket. Du kan til enhver tid tilbagekalde dit samtykke på info@starmark.dk';
          }

          label.customPolicyLabel:before {
            content: 'Jeg accepterer vilkårene for';
          }

          label.customPolicyLabel {
            a {
              color: black;
              &:before {
                content: ' persondatapolitikken';
              }
            }
          }
        }
      }

      .info {
        border-top: 1px solid var(--light-gray);

        p:first-of-type {
          display: none;
        }

        p {
          font-family: var(--font-family);
          font-style: normal;
          font-weight: 400;
          font-size: 1rem;
          line-height: 1.188rem;

          a {
            text-decoration: none;
            font-weight: 700;
          }
        }
      }
    }
  }
}
// end styles for seez-test-drive-modal

// start styles for seez-sdk-unavailable-listing-modal
seez-sdk-unavailable-listing-modal {
  .seezModal > div {
    --highlight: #5bc2f4;

    .buttonWrapper {
      button {
        background-color: var(--highlight) !important;
        color: var(--white) !important;
        border-radius: 12px !important;
        font-family: var(--font-family);
      }
    }

    .carousel .listingCard {
      @include starmark-listing-card(var(--card-height), var(--card-financing-display), var(--card-leasing-display));
      text-align: start;
    }

    svg > path {
      fill: var(--highlight);
    }
  }
}
// // end styles for seez-sdk-unavailable-listing-modal

.loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  min-height: 100vh;
}

.sliderOffersWrapper {
  width: 100%;
  padding-top: 2rem;

  > .sliderOffersHeading {
    font-family: var(--font-heading);
    font-weight: 400;
    font-size: 1.994rem;
    line-height: 2.25rem;
    margin: 1rem 0;
    color: black;
  }
  &.hidden * {
    display: none;
  }
}
.hidden * {
  display: none;
}
</style>
